/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.blockModule')
.controller('BlockViewSwitcherController', ['$scope', 'BulbBlockViewSwitcherService', BlockViewSwitcherController]);

/**
 * AngularJS controller for switching between list/tile view of blocks.
 */
function BlockViewSwitcherController($scope, BulbBlockViewSwitcherService) {

  $scope.viewSwitcherService = BulbBlockViewSwitcherService;


  /**
   * Function that switches the user's view to block-tile view.
   */
  this.showTile = function() {
    var view = 'tile';
    BulbBlockViewSwitcherService.disableDraggingForArchiveCollection(view);
    BulbBlockViewSwitcherService.updateAccountPreferences(this.infoType, true);
  };  

  /**
   * Function that switches the user's view to list view.
   */
  this.showList = function() {
    var view = 'list';
    BulbBlockViewSwitcherService.disableDraggingForArchiveCollection(view);
    BulbBlockViewSwitcherService.updateAccountPreferences(this.infoType, false);
  };

  /**
   * Function that determines whether or not the differing views can be displayed -- i.e block-tile or list.
   * @returns {Boolean} Whether the view switcher could be displayed or not.
   */
  this.isDisplayed = function() {
    return BulbBlockViewSwitcherService.isSwitchable(this.infoType);
  };

}


